import { createContext } from 'use-context-selector';
import { createProvider } from 'domain/createProvider';
import { TUpdate } from 'domain/types';

export type NotificationSettings = {
  id: number | null;
  newMessagesApp: boolean;
  jobApplicationStatusApp: boolean;
  newMessagesEmail: boolean;
  jobApplicationStatusEmail: boolean;
};

export type TProfileConfigContextState = {
  isOpenProfileCreatedModal: boolean;
  isOpenHideAccountModal: boolean;
  isOpenShowAccountModal: boolean;
  isOpenDeleteAccountModal: boolean;
  notificationSettings: NotificationSettings;
  recruiterPreferencesData: any;
  jobSeekerPreferencesData: any;
  update?: TUpdate<TProfileConfigContextState>;
};

const initState: TProfileConfigContextState = {
  isOpenProfileCreatedModal: false,
  isOpenHideAccountModal: false,
  isOpenShowAccountModal: false,
  isOpenDeleteAccountModal: false,
  notificationSettings: {
    id: null,
    newMessagesApp: false,
    jobApplicationStatusApp: false,
    newMessagesEmail: false,
    jobApplicationStatusEmail: false,
  },
  recruiterPreferencesData: {},
  jobSeekerPreferencesData: {},
};

export const ProfileConfigContext = createContext<TProfileConfigContextState>(initState);

export const ProfileConfigProvider = createProvider(ProfileConfigContext, initState);
